export const OVERALL_RANKING_COLUMN_STATE_KEY = 'overallRankingTableColumnState'
export const USER_MANAGEMENT_COLUMN_STATE_KEY = 'userManagementTableColumnState'
export const TICKER_MANAGEMENT_COLUMN_STATE_KEY =
  'tickerManagementTableColumnState'
export const IDEA_LIST_COLUMN_STATE_KEY = 'ideaListTableColumnState'
export const IDEA_HISTORY_COLUMN_STATE_KEY = 'ideaHistoryTableColumnState'
export const STATISTICS_LIST_COLUMN_STATE_KEY = 'statisticsListTableColumnState'
export const POSITION_LIST_COLUMN_STATE_KEY = 'positionListTableColumnState'
export const MAIL_LIST_COLUMN_STATE_KEY = 'mailListTableColumnState'
export const SHOW_IDEA_LIST_TUTORIAL_BANNER = 'showIdeaListTutorialBanner'
export const IDEA_LIST_MOBILE_CARD_VIEW_KEY = 'ideaListMobileCardView'
export const STAR_SCORE_MAX = 5
export const STAR_SCORE_MIN = 2.5

export const INTERNAL_EMAIL_DOMAINS = [
  '@polymercapital.com',
  '@pag.com',
  '@polymercp-us.com',
]

export function isInternalEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase()
  return INTERNAL_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain))
}

// en-GB omits the Oxford comma: "A, B or C"
const LIST_FORMAT_LOCALES: Record<string, string> = {
  en: 'en-GB',
  tw: 'zh-TW',
  cn: 'zh-CN',
  jp: 'ja',
}

export function formatInternalEmailDomains(language: string): string {
  return new Intl.ListFormat(LIST_FORMAT_LOCALES[language] ?? 'en-GB', {
    type: 'disjunction',
  }).format(INTERNAL_EMAIL_DOMAINS)
}
